import { useState, useEffect } from "react";

import { Form, FormInstance, Card, Tabs, Row, Col, Checkbox, TabsProps } from "antd";

import { apiCand } from "../../../services/apiCand";

import "../style.css";

import { converterCargo, IMandatoDirigenteConsulta } from "../../Mandato/Componentes/InterfaceMandato";

import PessoaFisicaDocumento from "./PessoaFisicaDocumento"
import PessoaFisicaEndereco from "./PessoaFisicaEndereco";
import PessoaFisicaEmail from "./PessoaFisicaEmail"
import PessoaFisicaTelefone from "./PessoaFisicaTelefone"
import PessoaFisicaFormacao from "./PessoaFisicaFormacao"
import PessoaFisicaExperiencia from "./PessoaFisicaExperiencia"
import PessoaFisicaCertificado from "./PessoaFisicaCertificado"
import PessoaFisicaPenalidade from "./PessoaFisicaPenalidade"
import PessoaFisicaPepSituacao from "./PessoaFisicaPepSituacao"
import PessoaFisicaCargoMandato from "./PessoaFisicaCargoMandato";

import {
  IFormacaoPessoaFisica, IEnderecoPessoaFisica,
  IDocumentoPessoaFisica, IEmailPessoaFisica,
  ITelefonePessoaFisica, IExperienciaPessoaFisica,
  ISituacaoPepPessoaFisica, IDadosReceitaCpf,
  ICertificadoPessoaFisica, IPenalidadePessoaFisica,
  IPessoaFisica
} from "./InterfacePessoaFisica";

import { color } from "../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail } from "../../../utils/messages";
import { IOutroCargoConsulta } from "../../OutroCargo/Componentes/InterfaceOutroCargo";
import { IDirigenteExcepcionalConsulta } from "../../DirigenteExcepcional/Componentes/InterfaceDirigenteExcepcional";
import { IErroApi } from "../../../Interfaces/Interfaces";

interface IProps {
  form: FormInstance<any>;
  idPessoaFisica?: number;
  mostrarDetalhesPessoaFisica: boolean;
}

const PessoaFisicaDadosPessoaisComplementares = ({ form, idPessoaFisica, mostrarDetalhesPessoaFisica }: IProps) => {
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mostrarDetalhesPessoaFisica && !dadosPessoaFisica) {
     if (idPessoaFisica) getPfById(idPessoaFisica);
    }
  }, [mostrarDetalhesPessoaFisica]);

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi );
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");
    }
  }, [erroApi])


  // SEÇÃO REFERENTE AOS DADOS DE PESSOA FÍSICA

  const [dadosPessoaFisica, setDadosPessoaFisica] = useState<IPessoaFisica>();
  const [documentos, setDocumentos] = useState<IDocumentoPessoaFisica[]>([]);
  const [enderecos, setEnderecos] = useState<IEnderecoPessoaFisica[]>([]);
  const [emails, setEmails] = useState<IEmailPessoaFisica[]>([]);
  const [telefones, setTelefones] = useState<ITelefonePessoaFisica[]>([]);
  const [formacoes, setFormacoes] = useState<IFormacaoPessoaFisica[]>([]);
  const [experiencias, setExperiencias] = useState<IExperienciaPessoaFisica[]>([]);
  const [certificados, setCertificados] = useState<ICertificadoPessoaFisica[]>([]);
  const [penalidades, setPenalidades] = useState<IPenalidadePessoaFisica[]>([]);
  const [pessoaFisicaPepSituacoes, setPessoaFisicaPepSituacoes] = useState<ISituacaoPepPessoaFisica[]>([]);
  const [mandatosDirigentes, setMandatosDirigentes] = useState<IMandatoDirigenteConsulta[]>([]);
  const [outrosCargos, setOutrosCargos] = useState<IOutroCargoConsulta[]>([]);
  const [dirigentesExcepcionais, setDirigentesExcepcionais] = useState<IDirigenteExcepcionalConsulta[]>([]);

  const [dadosReceitaCpf, setDadosReceitaCpf] = useState<IDadosReceitaCpf>({});
  const [pepSituacoes, setPepSituacoes] = useState([]);
  const [estadoPEP, setEstadoPEP] = useState(false);

  // Retorna os dados do cadastro de pessoa física da base
  const getPfById = async (value: number) => {
    if (value === 0) {
      errorMessage("Erro ao identificar o ID da pessoa física para carregar os dados complementares.")
    };

    setLoading(true);
    await apiCand.get(`/pessoasFisicas/${value}/full`).then((response) => {
      setLoading(false);
      setDadosPessoaFisicaFull(response?.data);
    })
      .catch(err => {
        setLoading(false);
        if (err.response.status !== 404) {
          setErroApi(err.response.data);
        }
      });
  };

  function setDadosPessoaFisicaFull(data: IPessoaFisica) {
    setDadosPessoaFisica(data);
    setDocumentos(data.pessoaFisicaDocumentos);
    setEmails(data.pessoaFisicaEmails);
    setTelefones(data.pessoaFisicaTelefones);
    setEnderecos(data.pessoaFisicaEnderecos);
    setFormacoes(data.pessoaFisicaFormacoes);

    setExperiencias(data.pessoaFisicaExperienciasProfissionais);
    setCertificados(data.pessoaFisicaCertificados);
    setPenalidades(data.pessoaFisicaPenalidades);
    setPessoaFisicaPepSituacoes(data.pessoaFisicaPepSituacoes);

    setMandatosDirigentes(data.pessoaFisicaMandatoDirigentes || []);
    setOutrosCargos(data.pessoaFisicaOutrosCargos || []);
    setDirigentesExcepcionais(data.pessoaFisicaDirigentesExcepcionais || []);
  }

  function isPPE() {
    if (pessoaFisicaPepSituacoes.length > 0 && verificaSitSemDtFim()) {
      form.setFieldsValue({
        pessoaExpostaPoliticamente: true,
      });
      return true;
    } else {
      form.setFieldsValue({
        pessoaExpostaPoliticamente: false,
      });
      return false;
    }
  }

  function verificaSitSemDtFim() {  // SE EXISTIR PELO MENOS UM REGISTRO COM DT_FIM NULL, RETORNA TRUE
    let existeRegSemDtFim = false;
    if (pessoaFisicaPepSituacoes.length > 0) {
      pessoaFisicaPepSituacoes.forEach((e: ISituacaoPepPessoaFisica) => {
        if (!e.dtFim || e.dtFim === null || e.dtFim === "") existeRegSemDtFim = true;
      });
    }
    return existeRegSemDtFim;
  }

  const abas : TabsProps['items'] = [
    {
      key: 'item-1',
      label: 'Documentos',
      children:
        <PessoaFisicaDocumento
          form={form}
          paises={[]}
          estados={[]}
          documentos={documentos}
          setDocumentos={setDocumentos}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-2',
      label: 'E-mails',
      children:
        <PessoaFisicaEmail
          form={form}
          emails={emails}
          setEmails={setEmails}
          color={color}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-3',
      label: 'Telefones',
      children:
        <PessoaFisicaTelefone
          form={form}
          telefones={telefones}
          setTelefones={setTelefones}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-4',
      label: 'Endereços',
      children:
        <PessoaFisicaEndereco
          paises={[]}
          estados={[]}
          enderecos={enderecos}
          setEnderecos={setEnderecos}
          form={form}
          manter={2} // CONSULTAR
          dadosReceitaCpf={{}}
          setDadosReceitaCpf={setDadosReceitaCpf}
        />
    },
    {
      key: 'item-5',
      label: 'Formação',
      children:
        <PessoaFisicaFormacao
          formacoes={formacoes}
          setFormacoes={setFormacoes}
          areas={[]}
          form={form}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-6',
      label: 'Experiência Profissional',
      children:
        <PessoaFisicaExperiencia
          experiencias={experiencias}
          setExperiencias={setExperiencias}
          areas={[]}
          ocupacoes={[]}
          form={form}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-7',
      label: 'Certificado',
      children:
        <PessoaFisicaCertificado
          certificados={certificados}
          setCertificados={setCertificados}
          form={form}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-8',
      label: 'Penalidade',
      children:
        <PessoaFisicaPenalidade
          penalidades={penalidades}
          setPenalidades={setPenalidades}
          form={form}
          cargos={converterCargo(mandatosDirigentes, outrosCargos, dirigentesExcepcionais)}
          manter={2} // CONSULTAR
        />
    },
    {
      key: 'item-9',
      label: 'Pessoa Exposta Politicamente',
      children:
        <>
          <Row>
            <Col xs={12} xl={12}>
              <Form.Item
                name="pessoaExpostaPoliticamente"
                colon={false}
              >
                <Checkbox defaultChecked={estadoPEP} checked={isPPE()} disabled={true}>Pessoa Exposta Politicamente</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          <PessoaFisicaPepSituacao
            pessoaFisicaPepSituacoes={pessoaFisicaPepSituacoes}
            setPessoaFisicaPepSituacoes={setPessoaFisicaPepSituacoes}
            pepSituacoes={pepSituacoes}
            form={form}
            manter={2} // CONSULTAR
          />
        </>
    },
    {
      key: 'item-10',
      label: 'Cargos e Mandatos',
      children:
        <PessoaFisicaCargoMandato
          form={form}
          mandatosDirigentes={mandatosDirigentes}
          outrosCargos={outrosCargos}
          dirigentesExcepcionais={dirigentesExcepcionais}
        />
    }
  
  ];

  return (
    <>
      <Card title={"Dados Pessoais - Detalhe"} loading={loading} variant="outlined" style={{ width: "100%" }}>
        <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }}>
          <Tabs items={abas} />
        </Row>
      </Card>
    </>
  );
};

export default PessoaFisicaDadosPessoaisComplementares;